
import React from 'react'
import _ from 'lodash'
import { } from 'highcharts/'
import Highcharts from 'highcharts'
import Exporting from 'highcharts/modules/exporting'
import SVHGViewDraw from './SVHGViewDraw'
import SVGraphSigma from './SVGraphSigma'
import {SV_SOJ_ORCMOCK_ADDRESS} from '../../constants'

/*
import SVGraphComponent from './SVGraphComponent';
*/
import './nms.css'
Exporting(Highcharts)

const NO_FIELD = 'NO_NAME'


export default class OPieMapDyna extends React.Component {
    /*
    slideTime(delta) {
        var me = this

        var zone = "America/Los_Angeles";
        me.$graphComponent.changeUSDateWithTime(me.svGraphEdge.svtimeRange, delta, zone);
        me.syncItin();


    };
    */
    syncItinsyncItin() {

        let me = this
        me.svHrtGraphEdge.svtimeRange.startUtc = me.props.svitin.svShortFrom;
        me.svHrtGraphEdge.svtimeRange.endUtc = me.props.svitin.svShortTo;
        //console.log('sv timerange changed')
        //console.log(me.svHrtGraphEdge)


    };

    componentWillReceiveProps(n) {

        const { load } = this.props
        let me = this
        //console.log('sv***********gene new props')
        //console.log(n)
        //console.log(this.props.svitin.startLong + ";differ" + n.svitin.startLong)

        let newStartLong = n.svitin.startLong
        let oldStartLong = this.props.svitin.startLong


        

    }
    syncItin(){
          let me =this
          
           me.svGraphEdge.svtimeRange.startUtc = me.props.svitin.svShortFrom;
           me.svGraphEdge.svtimeRange.endUtc = me.props.svitin.svShortTo;
           //console.log('sv timerange changed')
           //console.log( me.svGraphEdge)
     
    };
    hrtDynaEvents() {
        let me = this
        var evt, all;

        let { categories} = me
        all = Object.keys(categories);

        for (var i = 0; i < all.length; i++) {
            if (all[i] == 'currentWeek') {
                continue;
            }
            evt = new Object();
            evt.name = all[i];
            evt.value = all[i];
            me.graphHrtCat.events.push(evt);
        }


    };
    getHrtUserSeries(ob) {
        let me = this
        let { categories, biMetaDataOrder, svcategoriesArray, svTimePositions, userInboundValues, userOutboundValues, graphPeerExcel } = me
        categories = {};
        svTimePositions = [];
        userInboundValues = [];
        userOutboundValues = [];
        /*



"value": {
"startDate": "04/27/2017",
"endDate": "05/12/2017",
"hasbro": {
    "limit": 10,
    "in_use": 3
},
"carnivalLive": {
    "limit": 10,
    "in_use": 1
},
"lipsync": {
    "limit": 10,
    "in_use": 3
},
"imax": {
    "limit": 10,
    "in_use": 4
},
"karoke": {
    "in_use": 0
},
"hipship": {
    "limit": 20,
    "in_use": 1
},
"slide": {
    "limit": 10,
    "in_use": 1
},
"rock": {
    "limit": 20,
    "in_use": 7
}
}
        */
    
        let {biProduct} = this
        var datain = [],
            dataout = [],
            /*svs5*/
            fact = biMetaDataOrder.currentMeasure,
            /*svs5..*/
            eventNamesForCat = [], aggFieldName, agTotalFieldName = 'Totaloccupancy';
        var svAGFact = 'occupancy';



        if (me.svHrtGraphEdge.filterState.svreportType == 'SVBITYPE_PRODUCT') {
            /*svs5..*/
            // svAGFact = 'list_unit_price';
            svAGFact = fact;

            /*svs5..*/

        } else {
            svAGFact = 'occupancy';
        }
        agTotalFieldName = 'Total' + svAGFact;
        aggFieldName = me.$graphSigma.aggegationName(me.svHrtGraphEdge.sigma.type) + svAGFact;
        // aggFieldName = $graphSigma.aggegationName($scope.svHrtGraphEdge.sigma.type) +'occupancy';
        graphPeerExcel.aggFieldName = aggFieldName;
        graphPeerExcel.aggTypeName = me.$graphSigma.aggegationName(me.svHrtGraphEdge.sigma.type);



        _.forEach(ob, function (v, k) {

            if (v && _.isObject(v)) {
                if (biProduct == 'SVBITYPE_SVCLOG') {
                    v = v[0];
                }

                var boundOb = {},
                    pmax, pmin;
                boundOb.name = k;

                svTimePositions.push(k);
                if (me.svHrtGraphEdge.sigma.type == 1) {
                    //boundOb.y = v.Totaloccupancy;

                    if (biProduct == 'SVBITYPE_SVCLOG') {
                        v.name = k
                        boundOb = _.clone(v)
                        boundOb.name = k
                        userInboundValues.push(boundOb);
                    } else {

                        boundOb.y = v[agTotalFieldName];
                        userInboundValues.push(boundOb);

                    }


                    /*  userInboundValues.push({
                          name:v.svoccupancy ,
                         y: v.Totaloccupancy
  
                      }); */


                } else {
                    //userInboundValues.push(v[aggFieldName]);
                    boundOb.y = v[aggFieldName];
                    userInboundValues.push(boundOb);
                    /*
            userInboundValues.push({
                name:v.svoccupancy ,
               y: v[aggFieldName]

            });
            */

                }


                boundOb.userInboundValues = [];
                boundOb.userOutboundValues = [];
                boundOb.userInboundValues = _.clone(v);
                datain.push(v);
                dataout.push(0)
                me.categories[k] = boundOb;
                //console.log(datain)
                eventNamesForCat.push(k);
            }
            //console.log('svh rtt c console.log(datain)')
            console.log(me.categories)


        });
        me.updateYAxisTick();
        svcategoriesArray = _.clone(eventNamesForCat);
        me.categories['currentWeek'] = {};
        me.categories['currentWeek'].userInboundValues = datain;
        me.categories['currentWeek'].userOutboundValues = dataout;


    }
    updateYAxisTick() {
        var me = this

        if (me.userInboundValues.length > 0 && (_.isArray(me.userInboundValues))) {

            var now = _.clone(me.userInboundValues);
            me.svmin = now.sort()[0];
        }

    };
    spHrtContentRefresh(obAccount) {

        this.globalAllocationHrtSV(obAccount);
    }


    notifyValueHrtSVSvclog(encryptedIndividualAccount) {
        // let me = this, url = 'http://localhost:3004/svelkParallelSearch'
        // url="http://localhost:3004/svelkAllEnvErrors";
        let me = this, url = 'http://localhost:3004/elkOsrTypeOfErrors'

        //url = 'http://localhost:3004/elkOsrChart'
        //url = 'http://localhost:8086/essearch/pieAir'
        url = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/pieAir`
        var deferred,
            quote;

        if (me.svcall && me.svserver) {
          //  url = me.svserver + '/' + me.svcall
            //console.log('sv endpoint -------------' + url)
        }

        if (this.svCallType != 'POST') {
            if (this.props.svmetadata.svQueryGet && (this.props.svmetadata.svQueryGet.length > 0)) {
              //  url = me.svserver + '/' + me.svcall + '/' + this.props.svmetadata.svQueryGet
            }
            //console.log('sv endpoint GET-------------' + url)
            return fetch(url)
                .then((rs) => {
                    return rs.json()

                })
                .catch((e) => {
                    //console.log('service error')
                    Promise.resolve(e)

                })
        }
        //console.log('sv endpoint POST-------------' + url)
        var svrq = {};
        if (encryptedIndividualAccount && (encryptedIndividualAccount != null)) {

            svrq = {
                "value": {
                    "vessel": me.svHrtGraphEdge.currentVessel.value,
                    "query": encryptedIndividualAccount,
                    "startRecord": ""
                }
            };

        } else {

            svrq = {
                "value": {
                    "vessel": me.svHrtGraphEdge.currentVessel.value,
                    "query": encryptedIndividualAccount,
                    "startRecord": ""
                }
            };

        }
        svrq.value.startLong = me.svGraphEdge.svtimeRange.startLong;
        svrq.value.endLong = me.svGraphEdge.svtimeRange.endLong;


        //svelkParallelSearch


        // oceanShipSideService.svSvclogPeerTrident_micro(svrq)

        let postRq = {
            method: 'POST',
            body: JSON.stringify(svrq),
            headers: {
                'Accept-Type': 'application/json',
                'Content-Type': 'application/json'
            }
        }


        return fetch(url, postRq)
            .then((rs) => {
                return rs.json()

            })
            .catch((e) => {
                console.log('service error')
                Promise.resolve(e)

            })

    }
/*
     svSnapToday(rs, dashYYYYmmdd) {
        var ar = rs.data.orders;
        var selectedDay = [],
            view, test = false;
        for (var i = 0; i < ar.length; i++) {
            test = false
            view = ar[i];
            if (view.timestamp && (view.timestamp.length > 5)) {
                test = isThisDay(view.timestamp, svTodayDate);
            }
            if (test === true) {
                selectedDay.push(view);
            }
        }

        var out = {
            data: {
                orders: selectedDay
            }
        };
        out.meta = _.clone(rs.meta);

        return out;

    }
*/
    globalAllocationHrtSV(obAccount) {
        var me = this
        let biProduct = 'SVBITYPE_SVCLOG'
        var calls;

        /*if (obAccount && obAccount.query) {

            calls = [$scope.notifyValueHrtSV(obAccount.query)];
        } else {

            calls = [$scope.notifyValueHrtSV()];
        }*/

        if (biProduct == 'SVBITYPE_PRODUCT') {

            if (obAccount && obAccount.query) {



                calls = [me.notifyValueHrtSVProduct(obAccount.query)];
            } else {

                calls = [me.notifyValueHrtSVProduct()];
            }

        } else if (biProduct == 'SVBITYPE_SVCLOG') {

            if (obAccount && obAccount.query) {



                calls = [me.notifyValueHrtSVSvclog(obAccount.query)];
            } else {

                calls = [me.notifyValueHrtSVSvclog()];
            }


        } else {

            if (obAccount && obAccount.query) {

                calls = [me.notifyValueHrtSV(obAccount.query)];
            } else {

                calls = [me.notifyValueHrtSV()];
            }

        }

        Promise.all(calls)
            .then(function (alloc) {
                var downstreamValues = alloc[0],
                    allValues, raw,
                    pastValues,
                    outbound,


                    error = false,
                    annualValues,
                    statusCode,
                    svFunded = true,
                    infoGraph, modellerRs = {
                        data: {
                            value: {}
                        }
                    };


                let { categories} = me

                var statusInfo = null;
                if (downstreamValues.length < 1) {
                    return me.emptyChartNoError();
                }
                if (me.SVHNTT_DAILY === true) {

                    if (biProduct == 'SVBITYPE_SVCLOG') {
                        /*
                    } else {
                        downstreamValues = me.svSnapToday(downstreamValues, svTodayDate);
                        */
                    }

                }
                if (me.svHrtGraphEdge.filterState.isfilterApplied === true) {

                    if (biProduct == 'SVBITYPE_SVCLOG') {

                        me.stopColors = ['#ff8080', '#66ff66', '#009900', '#ff9933', '#ffff00', '#b32d0']
                        var flatAr = downstreamValues.data.list;
                        // var flatAr =  downstreamValues.aggregations[2].buckets;
                        downstreamValues = flatAr;

                        allValues = me.svPipePointsHeaderNoFilterSvclogAll(downstreamValues);


                    } else {
                        allValues = me.svPipePointsFilteredView(downstreamValues);
                    }




                } else {

                    if (me.svHrtGraphEdge.currentVessel.topValue != 'svall') {

                        //sva30
                        if (biProduct == 'SVBITYPE_PRODUCT') {
                            allValues = me.svPipePointsHeaderNoFilterSlr(downstreamValues);


                        } else if (biProduct == 'SVBITYPE_SVCLOG') {

                            me.stopColors = ['#ff8080', '#66ff66', '#009900', '#ff9933', '#ffff00', '#b32d0']
                           

                            /*svnov29 y25 start*/
                             //var flatAr = downstreamValues.data.list;
                           // var flatAr =  downstreamValues.aggregations[2].buckets;
                             // downstreamValues = flatAr;
                        /*svnov29 y25 start
                           const aggregations = downstreamValues.aggregations;
                           const by_activity_sv = aggregations['by_activity_sv']
                            var flatAr =  by_activity_sv.buckets;
                            */
                            var flatAr =  downstreamValues.airlines;
                            downstreamValues = flatAr;
                             /*svnov29 y25 end*/

                            allValues = me.svPipePointsHeaderNoFilterSvclogAll(downstreamValues);



                            // allValues = svPipePoints(downstreamValues);

                        } else {
                            // allValues = svPipePointsSlr(downstreamValues);
                            allValues = me.svPipePointsHeaderNoFilter(downstreamValues);
                        }

                        //sva30..
                        /* allValues = svPipePointsHeaderNoFilter(downstreamValues);*/

                    } else {
                        if (biProduct == 'SVBITYPE_PRODUCT') {
                            allValues = me.svPipePointsSlr(downstreamValues);

                            // allValues = svPipePoints(downstreamValues);
                        } else if (biProduct == 'SVBITYPE_SVCLOG') {

                            me.stopColors = ['#ff8080', '#66ff66', '#009900', '#ff9933', '#ffff00', '#b32d0']
                            var flatAr = downstreamValues.data.list;
                            // var flatAr =  downstreamValues.aggregations[2].buckets;
                            downstreamValues = flatAr;

                            allValues = me.svPipePointsHeaderNoFilterSvclogAll(downstreamValues);




                        } else {

                            allValues = me.svPipePoints(downstreamValues);
                        }



                    }

                    /*
                                        if ($scope.svHrtGraphEdge.currentVessel.topValue != 'svall') {
                                            allValues = svPipePointsHeaderNoFilter(downstreamValues);
                    
                                        } else {
                    
                                            allValues = svPipePoints(downstreamValues);
                                        }
                    */

                }

                if (allValues && allValues.data.value) {
                    raw = allValues.data.value;
                    modellerRs.startDate = raw.startDate;
                    modellerRs.endDate = raw.endDate;
                    //Step form that categories 
                    me.getHrtUserSeries(raw);
                    me.hrtDynaEvents();

                    let   userInboundValuesDisplay =_.clone(categories['currentWeek'].userInboundValues);
                    if(_.isArray(userInboundValuesDisplay)){
                        me.userInboundValues = _.clone(userInboundValuesDisplay)
                    }else{
                      me.userInboundValues =[_.clone(userInboundValuesDisplay)] 
                    }
                  

                modellerRs.nmi = _.clone(categories['currentWeek'].userInboundValues);
                    modellerRs.nmo = _.clone(categories['currentWeek'].userOutboundValues);
                    modellerRs.page = categories;
                        
                       let chart_ar = raw['testBrowser']
                    modellerRs.nmi = chart_ar
//console.log('sv ==got categires')
//console.log(categories)

/*
                    var firstSeriesName = _.keys(categories)[0];
                    var firstSeries = me.categories[firstSeriesName];
                    if (firstSeries && firstSeries.userInboundValues) {

                      let   userInboundValuesDisplay =_.clone(categories[firstSeriesName].userInboundValues);
                      console.log('sv-----display  userInboundValues name, y')
                      console.log(userInboundValuesDisplay)
                      if(_.isArray(userInboundValuesDisplay)){

                      }else{
                        me.userInboundValues =[_.clone(userInboundValuesDisplay)] 
                      }
                    
                    

                        modellerRs.nmi =_.clone(categories[firstSeriesName].userInboundValues);
                        modellerRs.nmo =_.clone(categories[firstSeriesName].userInboundValues);

                        modellerRs.page = categories;

                    }
                    */

                    //Step gte userbound and uineroutbound 





                } else {


                    return;


                }

                infoGraph = {
                    ai: {
                        svac_range: ["May 1, 2017 - May 31, 2017", "Jun 1, 2017 - Jun 30, 2017", "Jul 1, 2017 - Jul 31, 2017", "Aug 1, 2017 - Aug 31, 2017", "Sep 1, 2017 - Sep 30, 2017", "Oct 1, 2017 - Oct 31, 2017", "Nov 1, 2017 - Nov 30, 2017", "Dec 1, 2017 - Dec 31, 2017", "Jan 1, 2018 - Jan 31, 2018", "Feb 1, 2018 - Feb 28, 2018", "Mar 1, 2018 - Mar 31, 2018", "Apr 1, 2018 - Apr 30, 2018", "May 1, 2018 - May 1, 2018"],
                        svac_totalinm_m: [100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112],
                        svac_totalonm_m: [200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212],
                        svall: 3000
                    }
                };
                if (error === true) {
                    return me.spError();
                }
                me.spHrtRenderService(modellerRs, null, null, infoGraph);
            });


    }
    svbroadcast(o) {

        console.log('send action')
    }
    uiHrt() {
        let me = this
        var baseFormat = this.IGViewDraw.gcDomainGuide();
        //console.log(baseFormat)
        //console.log('sv draw pie for data')
        //console.log( me.userInboundValues)
        //console.log('sv this.props.svchart.svid'+ this.props.svchart.svid)
        //var el = $('#svipur').highcharts({
        var el = Highcharts.chart(this.props.svchart.svid, {


            chart: {
                //backgroundColor:'#06005e',

                //backgroundColor: this.IGViewDraw.svOceanTheme(this.svtheme).backgroundColor,
                plotBackgroundColor: null,
                plotBorderWidth: null,
                plotShadow: false,
                type: 'pie'
            },
            title: {
                text: ' '
            },
            tooltipOld: {
                pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
            },
            tooltip: {
                useHTML: this.IGViewDraw.gcDomainMode(false),

                borderRadius: baseFormat.borderRadius,

                shadow: this.IGViewDraw.gcDomainMode(false),
                borderWidth: baseFormat.domainWidth,
                borderColor: baseFormat.domainOutline,

                /*  formatter:function(){

                    

                      var t = this.x,
                          $svHcTip,
                          name,
                          salesOrder=false,
                          point;

                      var s ='';
                        var graph = {

                          range:  'Orders : ' + $scope.svitin.svStartDate+' to  ' + $scope.svitin.svEndDate,
                          ann:12,
                          name: 'default',
                          est:30,
                          total:0,
                          percent:10

                      };



                     
                      point = this.series;

                      graph.name =this.key ? this.key :  point.name;
                      graph.est = 2;
                      graph.ann = this.y;                         
                      if(angular.isDefined(point.processedYData) && angular.isArray(point.processedYData)  &&(point.processedYData.length > 0) ){

                          angular.forEach(point.processedYData, function(v, idx) {
                               graph.total +=  v ;

                              } );

                          graph.percent =  (graph.ann / graph.total) * 100;
                         graph.total = math.round(graph.total, 2);


                          graph.percent = math.round(graph.percent, 2);
                      }else{

                           graph.total = 0;
                           graph.percent = 0;

                      }
                     
                      
                      if($scope.svchart.svstartBiReportType =='SVBITYPE_SVCLOG'){

                    
              
                      var container = $scope.hrtValue.container;

                           salesOrder = true;
                           s = ' <div class="svhdr" ><span>';

                            graph.range=  ''  + $scope.svHrtGraphEdge.svtimeRange.startUtc+' to  ' + $scope.svHrtGraphEdge.svtimeRange.endUtc;

                      s += graph.range;

                      s += '</span><hr></div><table class="svin-table"><tbody><tr class="svin-row ">';


                       if(salesOrder === true){
                             s += '<td class="svin-content text-muted"> Enviornment'   +'(Errors)' +'  </td><td  class="svin-amount svright">';


                              s += graph.ann;

                      }else{


                            s += '<td class="svin-content text-muted"> Enviornment'   +'(Errors)'  +'  </td><td  class="svin-amount svright">';


                           s +=  graph.ann;

                      }

                    
                      
                      s += '</td></tr> <tr class="svin-row"><td class="svin-content text-muted"> Name   </td><td  class="svin-amount svright">';




                      s += graph.name;

                      if(salesOrder === true){
                           s += '</td></tr> <tr class="svin-row"><td class="svin-content text-muted"> Total Errors   </td><td  class="svin-amount svright">';
                            s += graph.total;

                      }else{


                           s += '</td></tr> <tr class="svin-row"><td class="svin-content text-muted"> Total Errors  </td><td  class="svin-amount svright">';
                          
                           s +=  graph.total;

                      }

                     
                      s += '</td>  </tr> <tr class="svin-row"><td class="svin-content text-muted"> Errors Percentage </td>';
                      s += '<td class="svin-amount svright">';




                      s += graph.percent;

                      s += '</td></tr> </tbody></table></div>';

                      return s;
                      }

                      s = ' <div class="svhdr" ><span>';

                      s += graph.range;

                      s += '</span><hr></div><table class="svin-table"><tbody><tr class="svin-row ">';
                      s += '<td class="svin-content text-muted"> ' + ' Orders Placed' +'  </td><td  class="svin-amount svright">';


                       s += graph.ann;
                      
                      s += '</td></tr> <tr class="svin-row"><td class="svin-content text-muted"> Product Type   </td><td  class="svin-amount svright">';




                      s += graph.name;

                      s += '</td></tr> <tr class="svin-row"><td class="svin-content text-muted"> Total Orders  </td><td  class="svin-amount svright">';



                      s += graph.total;
                      s += '</td>  </tr> <tr class="svin-row"><td class="svin-content text-muted"> Orders Percentage </td>';
                      s += '<td class="svin-amount svright">';



                      s += graph.percent;

                      s += '</td></tr> </tbody></table></div>';

                      return s;

                  }*/
            },
            /*
            exporting: {
                buttons: {
                    contextButton: {
                        enabled: false,
                        menuItems: [{
                            text: 'Export to PNG (small)',
                            onclick: function () {
                                this.exportChart({
                                    width: 250
                                });
                            }
                        }, {
                            text: 'Median',
                            onclick: function () {
                                svbroadcast('SV_OR_AGG_SHOW', ['median', svcmpId]);
                            },
                            separator: false
                        }, {
                            text: 'Mean',
                            onclick: function () {
                                svbroadcast('SV_OR_AGG_SHOW', ['avg', svcmpId]);
                            },
                            separator: false
                        }, {
                            text: 'Sum',
                            onclick: function () {
                                svbroadcast('SV_OR_AGG_SHOW', ['sum', svcmpId]);
                            },
                            separator: false
                        }, {
                            text: 'Min',
                            onclick: function () {
                                svbroadcast('SV_OR_AGG_SHOW', ['min', svcmpId]);
                            },
                            separator: false
                        }, {
                            text: 'Max',
                            onclick: function () {
                                svbroadcast('SV_OR_AGG_SHOW', ['max', svcmpId]);
                            },
                            separator: false
                        }, {
                            text: 'Generate Report',
                            onclick: function () {
                                svbroadcast('SV_OR_AGG_REPORT', ['gen', svcmpId]);
                            },
                            separator: false

                        }, {
                            text: 'Export to PNG (large)',
                            onclick: function () {
                                this.exportChart();
                            },
                            separator: false
                        }]
                    }
                }
            },
            */
            plotOptions: {
                pie: {
                    allowPointSelect: true,
                    cursor: 'pointer',
                    //colors:['#7cb5e1','#f2f2f2', '#b380ff','#66ccff','#4dffff','#00cccc','#00b3b3'],
                    colors: me.stopColors,
                    /*   dataLabels: {
                           enabled: false,
                           format: '{point.percentage:.1f} %',
                           style: {
                               color: (Highcharts.theme && Highcharts.theme.contrastTextColor) || 'black'
                           },
                           connectorColor: 'silver'
                       }*/
                }
            },
            series: [{
                name: 'Arilines/Carriers Availability in (Number Of Cities IN USA)',
                /*svs8*/
                size: '70%',
                innerSize: '60%',
                /*svs8..*/
                data: me.userInboundValues
            }]
        });



        /*
                var el = $('#svipur').highcharts({
                    chart: {
                        type: 'bar'
                    },
                    title: {
                        text: ''
                    },
                    xAxis: {
        
                        categories: svTimePositions
                           
                    },
                    yAxis: {
                        stackLabels: {
                            style: {
                                color: '#800000'
                            },
                            enabled: true
                        },
                        min: svmin,
                        title: {
                            text: factInfo.unit
                        }
                    },
                    legend: {
                        reversed: true
                    },
                    plotOptions: {
                        bar: {
                            stacking: 'normal',
                            pointPadding: 0,
                            groupPadding: 0.05,
                            dataLabels: {
                                enabled: false
                            }
                        },
                        series: {
                            stacking: 'normal'
                        }
                    },
                    exporting: {
                        buttons: {
                            contextButton: {
                                menuItems: [{
                                    text: 'Export to PNG (small)',
                                    onclick: function() {
                                        this.exportChart({
                                            width: 250
                                        });
                                    }
                                }, {
                                    text: 'Median',
                                    onclick: function() {
                                        $rootScope.$broadcast('SV_OR_AGG_SHOW', ['median']);
                                    },
                                    separator: false
                                 }, {
                                    text: 'Mean',
                                    onclick: function() {
                                        $rootScope.$broadcast('SV_OR_AGG_SHOW', ['avg']);
                                    },
                                    separator: false  
                               }, {
                                    text: 'Sum',
                                    onclick: function() {
                                        $rootScope.$broadcast('SV_OR_AGG_SHOW', ['sum']);
                                    },
                                    separator: false    
                                }, {
                                    text: 'Min',
                                    onclick: function() {
                                        $rootScope.$broadcast('SV_OR_AGG_SHOW', ['min']);
                                    },
                                    separator: false               
                                 }, {
                                    text: 'Max',
                                    onclick: function() {
                                        $rootScope.$broadcast('SV_OR_AGG_SHOW', ['max']);
                                    },
                                    separator: false     
        
                                }, {
                                    text: 'Export to PNG (large)',
                                    onclick: function() {
                                        this.exportChart();
                                    },
                                    separator: false
                                }]
                            }
                        }
                    },
                    series: [{
                        name: 'Occupancy Snapshot',
                        color: {
                            linearGradient: {
                                x1: 0,
                                y1: 0,
                                x2: 0,
                                y2: 1
                            },
                            stops: [
                                    [0, '#ccebff'],
                                    [1, '#80ccff']
                                ]
                                
                        },
                        data: userInboundValues
                           
        
                    }]
                });
        
                */
        me.hrtSpread = el
    };

    uiHrtStatic() {
        var id = ('#' + this.props.svchart.svid)
        let me = this
        //console.log('sv chart id:' + this.props.svchart.svid)
        // var el = $('#svipur').highcharts({
        Highcharts.chart({})
        var el = Highcharts.chart(this.props.svchart.svid, {


            chart: {
                plotBackgroundColor: null,
                plotBorderWidth: null,
                plotShadow: false,
                type: 'pie'
            },
            title: {
                text: ''
            },
            /* tooltip: {
                 pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
             }, */
            /*  tooltip:{
                  useHTML: this.IGViewDraw.gcDomainMode(false),

                  borderRadius: baseFormat.borderRadius,

                  shadow: SVDraw.gcDomainMode(false),
                  borderWidth: baseFormat.domainWidth,
                  borderColor: baseFormat.domainOutline,
                  formatter:function(){

                      var graph = {

                          range: 'Orders: ' + $scope.svitin.svStartDate+' to  ' + $scope.svitin.svEndDate,
                          ann:12,
                          name: point.name,
                          est:30,
                          percent:10

                      };

                      var t = this.x,
                          $svHcTip,
                          name,
                          point;

                      var s ='';
                      if(angular.isDefined($scope.svitin) && angular.isDefined($scope.svStartDate)){
                          graph.range = 'Total Orders Placed:';
                          graph.range += '' + $scope.svitin.svStartDate + '-' + $scope.svitin.svEndDate;
                      }
                      point = this.series;
                     
                      graph.est = 2;

                      graph.total=10;
                      svt: point.name;


                      s = ' <div class="svhdr" ><span>';

                      s += graph.range;

                      s += '</span><hr></div><table class="svin-table"><tbody><tr class="svin-row ">';
                      s += '<td class="svin-content text-muted"> ' + ' Orders Placed' +'  </td><td  class="svin-amount svright">';


                       s += graph.ann;
                      
                      s += '</td></tr> <tr class="svin-row"><td class="svin-content text-muted"> Product Type   </td><td  class="svin-amount svright">';




                      s += name;

                      s += '</td></tr> <tr class="svin-row"><td class="svin-content text-muted"> Total Orders  </td><td  class="svin-amount svright">';



                      s += graph.total;
                      s += '</td>  </tr> <tr class="svin-row"><td class="svin-content text-muted"> Orders Percentage </td>';
                      s += '<td class="svin-amount svright">{point.percentage:.1f}%';



                      s += graph.percent;

                      s += '</td></tr> </tbody></table></div>';

                      return s;

                  }
              },*/
            /*  plotOptions: {
                  pie: {
                      allowPointSelect: true,
                      cursor: 'pointer',
                      dataLabels: {
                          enabled: true,
                          format: '<b>{point.name}</b>: {point.percentage:.1f} %',
                          style: {
                              color: (Highcharts.theme && Highcharts.theme.contrastTextColor) || 'black'
                          },
                          connectorColor: 'silver'
                      }
                  }
              },*/
            series: [{
                name: 'Occupancy',
                data: [
                    { name: 'AF', y: 56.33 },
                    {
                        name: 'Media Theater',
                        y: 24.03,
                        sliced: true,
                        selected: true
                    },
                    { name: 'Bath', y: 10.38 },
                    { name: 'Pool', y: 4.77 }, { name: 'Opera', y: 0.91 },
                    { name: 'Aiport', y: 0.2 }
                ]
            }]
        });

        /*
                 var el = $('#svipur').highcharts({
                     chart: {
                         type: 'bar'
                     },
                     title: {
                         text: ''
                     },
                     xAxis: {
        
                         categories: svTimePositions
                            
                     },
                     yAxis: {
                         stackLabels: {
                             style: {
                                 color: '#800000'
                             },
                             enabled: true
                         },
                         min: svmin,
                         title: {
                             text: factInfo.unit
                         }
                     },
                     legend: {
                         reversed: true
                     },
                     plotOptions: {
                         bar: {
                             stacking: 'normal',
                             pointPadding: 0,
                             groupPadding: 0.05,
                             dataLabels: {
                                 enabled: false
                             }
                         },
                         series: {
                             stacking: 'normal'
                         }
                     },
                     exporting: {
                         buttons: {
                             contextButton: {
                                 menuItems: [{
                                     text: 'Export to PNG (small)',
                                     onclick: function() {
                                         this.exportChart({
                                             width: 250
                                         });
                                     }
                                 }, {
                                     text: 'Median',
                                     onclick: function() {
                                         $rootScope.$broadcast('SV_OR_AGG_SHOW', ['median']);
                                     },
                                     separator: false
                                  }, {
                                     text: 'Mean',
                                     onclick: function() {
                                         $rootScope.$broadcast('SV_OR_AGG_SHOW', ['avg']);
                                     },
                                     separator: false  
                                }, {
                                     text: 'Sum',
                                     onclick: function() {
                                         $rootScope.$broadcast('SV_OR_AGG_SHOW', ['sum']);
                                     },
                                     separator: false    
                                 }, {
                                     text: 'Min',
                                     onclick: function() {
                                         $rootScope.$broadcast('SV_OR_AGG_SHOW', ['min']);
                                     },
                                     separator: false               
                                  }, {
                                     text: 'Max',
                                     onclick: function() {
                                         $rootScope.$broadcast('SV_OR_AGG_SHOW', ['max']);
                                     },
                                     separator: false     
        
                                 }, {
                                     text: 'Export to PNG (large)',
                                     onclick: function() {
                                         this.exportChart();
                                     },
                                     separator: false
                                 }]
                             }
                         }
                     },
                     series: [{
                         name: 'Occupancy Snapshot',
                         color: {
                             linearGradient: {
                                 x1: 0,
                                 y1: 0,
                                 x2: 0,
                                 y2: 1
                             },
                             stops: [
                                     [0, '#ccebff'],
                                     [1, '#80ccff']
                                 ]
                                 
                         },
                         data: userInboundValues
                            
        
                     }]
                 });
        
                 */
        me.hrtSpread = el;
    }



    redrawHrtBarsInit(ob) {
        // userInboundValues = categories['currentWeek'].userInboundValues;
        //  userOutboundValues = categories['currentWeek'].userOutboundValues;
        this.hrtSpread.redraw();



    };
    spHrtRenderService(json, size, startDate, infoGraph) {
        let me = this
        if (me.hrtShow) {
            if (json) {

                if (json.nmi && (json.nmi != null)) {

                    if ((json.nmi)) {
                        me.processPagesPeer(json, infoGraph);
                        me.processEvents(json);
                        // svgrantsGraphPages('page2', size);

                        me.uiHrt();

                        me.redrawHrtBarsInit();

                        /*   var m = $(  '#' +$scope.svchart.svid +' div.highcharts-container svg text');
                           if (m) {
                               m.last().hide();
                           }
                               */
                        //viewNetworkCurrent();


                    } else {

                        me.spError();
                    }


                } else {
                    me.spError();
                }


            } else {

                me.spError();


            }

        }

    };
    stackCategoryRemoveDuplicate(options) {
        var gob, catNamesAll, catNames, dw, catName, mutOb, deck1ValuesAr, svCatAr = [], groupName;
        var viewItems = options.items;
        var x = options.field;
        var y = options.actionOnField;
        var sum = options.action;
        groupName = options.groupName;

        dw = viewItems;

        gob = _.groupBy(dw, x);

        catNamesAll = _.pluck(dw, x);
        catNames = _.uniq(catNamesAll);
        for (var i = 0; i < catNames.length; i++) {
            catName = catNames[i]
            deck1ValuesAr = gob[catName];
            mutOb = _.clone(deck1ValuesAr[0]);
            mutOb.svcluster = false;
            if (deck1ValuesAr.length < 2) {
                svCatAr.push(_.copy(mutOb));
                continue;
            }
            mutOb.svcluster = true;
            for (var k = 0; k < deck1ValuesAr.length; k++) {
                var view = deck1ValuesAr[k];
                if (k < 1) {
                    continue;
                }
                if ((!_.isUndefined(sum)) && (sum == 'SUM')) {
                    mutOb[y] += view[y];
                } else {
                    mutOb[y] = view[y];
                }

            }
            svCatAr.push(_.copy(mutOb))
        }
        return svCatAr;
    }
    syncItin() {
        let me = this
        me.svHrtGraphEdge.svtimeRange.startUtc = me.svitin.svShortFrom
        me.svHrtGraphEdge.svtimeRange.endUtc = me.svitin.svShortTo
    }
    constructor(props) {
        super(props)
        this.IGViewDraw = new SVHGViewDraw()
        this.$graphSigma = new SVGraphSigma()
        /*
        this.$graphComponent = new SVGraphComponent()
        */
        this.graphTimeExcel = {}
        this.categories = {}
        this.SVHNTT_DAILY = true
        this.svvis = this.props.svchart.svvis || 'line'
        this.svcall = this.props.svmetadata.svendpoint || 'elkOsrChart'
        this.svserver = this.props.svmetadata.svServer || 'http://localhost:3004'
        this.svCallType = this.props.svmetadata.svMethod || 'POST'

        let layout = this.props.svchart.layout || 6
        this.svlayout = "col-xs-12 col-sm-6 col-md-6 col-lg-6"
        if (layout > 11) {
            this.svlayout = "col-xs-12 col-sm-12 col-md-12  col-lg-12"
        } else if (  (layout >= 9) && (layout < 7) ) {
            this.svlayout = "col-xs-12 col-sm-9 col-md-9 col-lg-9 voffset4"    
        } else if (  (layout >= 6) && (layout < 3) ) {
            this.svlayout = "col-xs-12 col-sm-6 col-md-6 col-lg-6 voffset4"
        } else if (layout <= 3) {
            this.svlayout = "col-xs-12 col-sm-2 col-md-2  voffset4"    

        }

        /*svhrmethids */
        this.spHrtRenderService = this.spHrtRenderService.bind(this)
        this.spHrtContentRefresh = this.spHrtContentRefresh.bind(this)
        this.uiHrt = this.uiHrt.bind(this)
       // this.svSnapToday = this.svSnapToday.bind(this)
        this.globalAllocationHrtSV = this.globalAllocationHrtSV.bind(this)
        this.getHrtUserSeries = this.getHrtUserSeries.bind(this)
        this.hrtDynaEvents = this.hrtDynaEvents.bind(this)
        this.updateYAxisTick = this.updateYAxisTick.bind(this)
        this.svbroadcast = this.svbroadcast.bind(this)
         /*svnov29 y25 start */
         this.svPipePointsHeaderNoFilterSvclog_1CatPie = this.svPipePointsHeaderNoFilterSvclog_1CatPie.bind(this)
         /*svnov29 y25 end */
        /*sv hrtdyna */
       
        this.svitin = { ...this.props.svitin }
        this.svTodayDate = this.props.svmetadata.svTodayDate
        this.instanceHrtShow = true
        this.biProduct = this.props.svchart.svstartBiReportType
        this.graphPeerExcel = {
            myId: 'svassetexcel1',
            data: [{
                name: 'sheet1',
                cols: ['lln', 'day', 'hr', 'coocupancy'],
                data: [{

                    rows: ['MediaTheater', 'Monday', 12, 40]

                }, {

                    rows: ['Pool', 'Tuesday', 14, 60]
                }]



            }],
            down: function () {



            },
            svdownload: function () { }
        };
        this.svTimePositions = [
            'Hasbro',
            'CarnivalLive',
            'Lipsync',
            'imax',
            'karoke',
            'svevent1',
            'svevent2',

        ]
        this.svcategoriesArray = [
            'Hasbro',
            'CarnivalLive',
            'Lipsync',
            'imax',
            'karoke',
            'svevent1',
            'svevent2',


        ]
        //this.SVHNTT_DAILY = this.svmetadata.SVHNTT_DAILY
        this.SVHNTT_DAILY = false
        this.hrtShow = true
        this.hrtValue = {
            container: 'guest-identity',
            svHeading: this.props.svchart.svHeading || 'Peer View',
            svDynaSliceName: 'Sea Day',
            hasAccountValueError: false,
            errorMsg: ''

        }
        this.graphEdgeOrder = {


            eventClientSearchShow: true,
            svtimeRange: {
                startLong: 1505519250437,
                endLong: 1505520150437,
                svpInterval: 15,
                svpUnit: 'min',
                startUtc: '',
                endUtc: '',

            },
            currentVessel: {
                name: 'Doral Princess 1',
                value: 'DoralPrincess.1',
                topValue: 'svall',
                topName: 'All'

            },
            filterState: {
                svreportType: 'SVBITYPE_OCCUPANCY',
                svdimField: 'product_type',
                afRequestLln: '',
                isfilterApplied: false,
                product_type: 'product_type',
                shipment_type: '',
                timestamp: '',
                list_unit_price: 0,
                quantity: 0
                // "day": "Tuesday",

            },
            svtimestamp: {
                idx: 'timestamp',
                type: 'TEXT'

            },
            svshipment_type: {
                idx: 'shipment_type',
                type: 'TEXT'

            },
            svlist_unit_price: {
                idx: 'list_unit_price',
                type: 'NUMBER'

            },
            svquantity: {
                idx: 'quantity',
                type: 'NUMBER'

            },
            svproduct_type: {
                idx: 'product_type',
                type: 'TEXT'

            }


        }


        this.graphEdgeSlog = {


            eventClientSearchShow: true,
            svtimeRange: {
                startLong: 1505519250437,
                endLong: 1505520150437,
                svpInterval: 15,
                svpUnit: 'min',
                startUtc: '',
                endUtc: '',

            },
            currentVessel: {
                name: 'Doral Princess 1',
                value: 'DoralPrincess.1',
                topValue: 'svall',
                topName: 'All'

            },
            currentMetricType: {
                name: 'cpuUtilization'

            },
            filterState: {
                svreportType: 'SVBITYPE_SLOG',
                //sv add artificially can cpuutilizatin/memory
                svdimField: 'product_type',
                afRequestLln: '',
                isfilterApplied: false,
                guest: 0,
                irq: 0,
                system: 0,
                wait: 0,
                idle: 0,

                user: 'user',
                total: 0,
                steal: 0,
                nice: 0,
                timestamp: ''
                // "day": "Tuesday",

            },
            svguest: {
                idx: 'guest',
                type: 'NUMBER'

            },
            svirq: {
                idx: 'irq',
                type: 'NUMBER'

            },
            svwait: {
                idx: 'wait',
                type: 'NUMBER'

            },

            svidle: {
                idx: 'idle',
                type: 'NUMBER'

            },

            svuser: {
                idx: 'user',
                type: 'NUMBER'

            },
            svtotal: {
                idx: 'total',
                type: 'NUMBER'

            },
            svsteal: {
                idx: 'steal',
                type: 'NUMBER'

            },
            svnice: {
                idx: 'nice',
                type: 'NUMBER'

            },
            svtimestamp: {
                idx: 'timestamp',
                type: 'TEXT'

            },

            svsystem: {
                idx: 'system',
                type: 'NUMBER'

            }



        };

        this.graphEdgeSvclog = {


            eventClientSearchShow: true,
            svtimeRange: {
                startLong: 1505519250437,
                endLong: 1505520150437,
                svpInterval: 15,
                svpUnit: 'min',
                startUtc: '',
                endUtc: '',

            },
            currentVessel: {
                name: 'Doral Princess 1',
                value: 'DoralPrincess.1',
                topValue: 'svall',
                topName: 'All'

            },
            currentMetricType: {
                name: 'servciesError'

            },
            filterState: {
                svreportType: 'SVBITYPE_SVCLOG',
                //sv add artificially can cpuutilizatin/memory
                svdimField: 'svclog',

                isfilterApplied: false,
                doc_count: 0,
                key: 0,

                key_as_string: ''
                // "day": "Tuesday",

            },
            svkey: {
                idx: 'key',
                type: 'NUMBER'

            },
            svkey_as_string: {
                idx: 'key_as_string',
                type: 'TEXT'

            },


            svdoc_count: {
                idx: 'doc_count',
                type: 'NUMBER'

            }





        }

        this.reportMetaData = {
            measures: [{
                name: 'occupancy',
                value: 'occupancy',
                range: {
                    min: 0,
                    max: 100
                },
                type: 'NUMBER'

            }, {

                name: 'hour',
                value: 'hour',
                range: {
                    min: 0,
                    max: 100
                },
                type: 'HH'
            }, {

                name: 'day',
                value: 'day',
                range: {
                    list: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
                    min: 0,
                    max: 100
                },
                type: 'WEEKDAY'
            }, {

                name: 'lln',
                value: 'lln',
                range: {
                    min: 0,
                    max: 100
                },
                type: 'TEXT'



            }]


        }
        this.biMetaDataOrder = {
            currentMeasure: _.clone(this.props.svchart.svstartMeasure),
            measures: [{
                name: 'quantity',
                value: 'quantity',
                range: {
                    min: 0,
                    max: 100
                },
                type: 'NUMBER'

            }, {

                name: 'list_unit_price',
                value: 'list_unit_price',
                range: {
                    min: 0,
                    max: 100
                },
                type: 'NUMBER'

            }, {

                name: 'timestamp',
                value: 'timestamp',
                range: {
                    min: 0,
                    max: 100
                },
                type: 'TEXT'
            }, {

                name: 'shipment_type',
                value: 'shipment_type',
                range: {
                    min: 0,
                    max: 100
                },
                type: 'TEXT'
            }, {

                name: 'product_type',
                value: 'product_type',
                range: {
                    min: 0,
                    max: 100
                },
                type: 'TEXT'



            }]


        };

        this.biMetaDataSVSvclog = {
            measures: [{
                name: 'doc_count',
                value: 'doc_count',
                range: {
                    min: 0,
                    max: 1000000
                },
                type: 'NUMBER'

            }]

        };


        this.biMetaDataOccupancy = {
            measures: [{
                name: 'occupancy',
                value: 'occupancy',
                range: {
                    min: 0,
                    max: 100
                },
                type: 'NUMBER'

            }, {

                name: 'hour',
                value: 'hour',
                range: {
                    min: 0,
                    max: 100
                },
                type: 'HH'
            }, {

                name: 'day',
                value: 'day',
                range: {
                    list: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
                    min: 0,
                    max: 100
                },
                type: 'WEEKDAY'
            }, {

                name: 'lln',
                value: 'lln',
                range: {
                    min: 0,
                    max: 100
                },
                type: 'TEXT'



            }]


        }
        this.stopColors = ['#7cb5e1', '#f2f2f2', '#b380ff', '#66ccff', '#4dffff', '#00cccc', '#00b3b3']
        /*svhrtdyna.. */
        // this. svvis = 'scatter'
        this.svtheme = {
            // theme:'SNOW_VENUS'
            theme: 'OCEAN_BLUE'
        };
        this.graphCat = {
            currentPlot: 'scatter',
            plots: [{


                name: 'Vertical Bars',
                value: 'column'
            }, {
                name: 'Bubbles ',
                value: 'scatter'
            }, {
                name: 'Line',
                value: 'line'

            }],

            currentEvent: '10.0.3.1',


            events: [{


                name: 'All Events',
                value: '10.0.3.1'

                /*     }, {
                         name: 'svpersist',
                         value: 'svpersist'


                     }, {
                         name: 'hasbro',
                         value: 'hasbro'

                     }, {
                         name: 'imax',
                         value: 'imax'
                     }, {
                         name: 'lipsync',
                         value: 'lipsync' */
            }]

        };
        this.state = {
            networkSpread: null,
            searchText: 'no'
        }
        this.osrValue = {
            svHeading: this.props.svchart.svHeading || 'Peer View',
            svEventsShow: this.props.svchart.svEventsShow,
            svDynaSliceName: 'Sea Day',
            hasAccountValueError: false,
            errorMsg: ''

        }
        this.graphEdgeOrder = {


            eventClientSearchShow: true,
            svtimeRange: {
                startLong: 1505519250437,
                endLong: 1505520150437,
                svpInterval: 15,
                svpUnit: 'min',
                startUtc: '',
                endUtc: '',

            },
            currentVessel: {
                name: 'Doral Princess 1',
                value: 'DoralPrincess.1',
                topValue: 'svall',
                topName: 'All'

            },
            filterState: {
                svreportType: 'SVBITYPE_OCCUPANCY',
                svdimField: 'product_type',
                afRequestLln: '',
                isfilterApplied: false,
                product_type: 'product_type',
                shipment_type: '',
                timestamp: '',
                list_unit_price: 0,
                quantity: 0
                // "day": "Tuesday",

            },
            svtimestamp: {
                idx: 'timestamp',
                type: 'TEXT'

            },
            svshipment_type: {
                idx: 'shipment_type',
                type: 'TEXT'

            },
            svlist_unit_price: {
                idx: 'list_unit_price',
                type: 'NUMBER'

            },
            svquantity: {
                idx: 'quantity',
                type: 'NUMBER'

            },
            svproduct_type: {
                idx: 'product_type',
                type: 'TEXT'

            }


        }


        this.graphEdgeSlog = {


            eventClientSearchShow: true,
            svtimeRange: {
                startLong: 1505519250437,
                endLong: 1505520150437,
                svpInterval: 15,
                svpUnit: 'min',
                startUtc: '',
                endUtc: '',

            },
            currentVessel: {
                name: 'Doral Princess 1',
                value: 'DoralPrincess.1',
                topValue: 'svall',
                topName: 'All'

            },
            currentMetricType: {
                name: 'cpuUtilization'

            },
            filterState: {
                svreportType: 'SVBITYPE_SLOG',
                //sv add artificially can cpuutilizatin/memory
                svdimField: 'product_type',
                afRequestLln: '',
                isfilterApplied: false,
                guest: 0,
                irq: 0,
                system: 0,
                wait: 0,
                idle: 0,

                user: 'user',
                total: 0,
                steal: 0,
                nice: 0,
                timestamp: ''
                // "day": "Tuesday",

            },
            svguest: {
                idx: 'guest',
                type: 'NUMBER'

            },
            svirq: {
                idx: 'irq',
                type: 'NUMBER'

            },
            svwait: {
                idx: 'wait',
                type: 'NUMBER'

            },

            svidle: {
                idx: 'idle',
                type: 'NUMBER'

            },

            svuser: {
                idx: 'user',
                type: 'NUMBER'

            },
            svtotal: {
                idx: 'total',
                type: 'NUMBER'

            },
            svsteal: {
                idx: 'steal',
                type: 'NUMBER'

            },
            svnice: {
                idx: 'nice',
                type: 'NUMBER'

            },
            svtimestamp: {
                idx: 'timestamp',
                type: 'TEXT'

            },

            svsystem: {
                idx: 'system',
                type: 'NUMBER'

            }



        };
        this.svHrtGraphEdge = {
            eventClientSearchShow: true,
            svtimeRange: {
                startLong: 1505519250437,
                endLong: 1505520150437,
                svpInterval: 15,
                svpUnit: 'min',
                startUtc: '',
                endUtc: '',

            },
            currentVessel: {
                name: 'Doral Princess 1',
                value: 'DoralPrincess.1',
                topValue: 'svall',
                topName: 'All'

            },
            filterState: {
                afRequestLln: '',
                isfilterApplied: false,
                lln: '',
                day: '',
                hour: 0
                    // "day": "Tuesday",

            },
            sigma: {
                type: 1

            },
            svhour: {
                idx: 'hour',
                type: 'hh'

            },
            svoccupancy: {
                idx: 'occupancy',
                type: 'NUMBER'

            },
            svday: {
                idx: 'day',
                type: 'WEEKDAY'

            },
            svlln: {
                idx: 'lln',
                type: 'TEXT'

            }


        };

        this.graphEdgeSvclog = {


            eventClientSearchShow: true,
            svtimeRange: {
                startLong: 1505519250437,
                endLong: 1505520150437,
                svpInterval: 15,
                svpUnit: 'min',
                startUtc: '',
                endUtc: '',

            },
            currentVessel: {
                name: 'Doral Princess 1',
                value: 'DoralPrincess.1',
                topValue: 'svall',
                topName: 'All'

            },
            sigma: {
                type: 1

            },
            currentMetricType: {
                name: 'servciesError'

            },
            filterState: {
                svreportType: 'SVBITYPE_SVCLOG',
                //sv add artificially can cpuutilizatin/memory
                svdimField: 'svclog',

                isfilterApplied: false,
                doc_count: 0,
                key: 0,

                key_as_string: ''
                // "day": "Tuesday",

            },
            svkey: {
                idx: 'key',
                type: 'NUMBER'

            },
            svkey_as_string: {
                idx: 'key_as_string',
                type: 'TEXT'

            },
            svhour: {
                idx: 'hour',
                type: 'hh'

            },
            svoccupancy: {
                idx: 'occupancy',
                type: 'NUMBER'

            },
            svday: {
                idx: 'day',
                type: 'WEEKDAY'

            },
            svlln: {
                idx: 'lln',
                type: 'TEXT'

            },

            svdoc_count: {
                idx: 'doc_count',
                type: 'NUMBER'

            }





        }

        this.networkValue = {
            svHeading: this.props.svchart.svHeading || 'Errors',

            svDynaSliceName: 'Sea Day',
            hasAccountValueError: false,
            errorMsg: '',
            accountId: 12,
            filter: [],
            horizonCType: {
                blockLimit: false,
                start: '',
                end: '',
                externs: []
            },
            svTimeSpan: [],
            today: true,
            change: 3000,
            allPackets: 0,
            allIncoming: 1000,
            allOutgoing: 2000,
            todayHoverPoint: true


        }



        this.graphEdgeOccupancy = _.clone(this.svGraphEdge)
        this.svGraphEdge = {
            eventClientSearchShow: true,
            svtimeRange: {
                startLong: 1506321211089,
                endLong: 1505804560682,
                svpInterval: 15,
                svpUnit: 'min',
                svEnv: 'DEV',
                startUtc: '',
                endUtc: '',

            },
            currentVessel: {


                name: 'Doral Princess 1',
                value: 'DoralPrincess.1',
                topValue: 'svall',
                topName: 'All'

            },
            filterState: {
                afRequestLln: '',
                svreportType: 'SVBITYPE_PRODUCT',
                svdimField: 'lln',
                isfilterApplied: false,
                lln: '',
                day: '',
                hour: 0
                // "day": "Tuesday",

            },
            svhour: {
                idx: 'hour',
                type: 'hh'

            },
            svoccupancy: {
                idx: 'occupancy',
                type: 'NUMBER'

            },
            svday: {
                idx: 'day',
                type: 'WEEKDAY'

            },
            svlln: {
                idx: 'lln',
                type: 'TEXT'

            }


        }
        this.svNms = this.svNms.bind(this)
        this.svRefreshBucket = this.svRefreshBucket.bind(this)
        this.onBiChange = this.onBiChange.bind(this)
        this.exrerciseLoadService = this.exrerciseLoadService.bind(this)
        this.svPipePointsHeaderNoFilterSvclog = this.svPipePointsHeaderNoFilterSvclog.bind(this)
        this.svPipePointsHeaderNoFilterSvclogAll = this.svPipePointsHeaderNoFilterSvclogAll.bind(this)
        //  this.spEovRenderService = this.spEovRenderService.bind(this)
        this.stackCategoryOrder = this.stackCategoryOrder.bind(this)
        this.addStopColor = this.addStopColor.bind(this)
        //this.globalAllocationValueEovSV_ConstructSeries = this.globalAllocationValueEovSV_ConstructSeries.bind(this)
        this.processPagesPeer = this.processPagesPeer.bind(this)
        this.processEvents = this.processEvents.bind(this)
        this.spError = this.spError.bind(this)
        this.svgrantsGraphPages = this.svgrantsGraphPages.bind(this)
        this.onBiChange = this.onBiChange.bind(this)
        this.stackCategoryOrder = this.stackCategoryOrder.bind(this)
        this.svPipeEvents = this.svPipeEvents.bind(this)
        this.persistAccountData = this.persistAccountData.bind(this)
        this.updateDataPageLoad = this.updateDataPageLoad.bind(this)
        this.svAnEvent = this.svAnEvent.bind(this)
        //this.svGraphEvents = this.svGraphEvents.bind(this)
        this.hexToRgbA = this.hexToRgbA.bind(this)
        this.hexToRgbAGenerate = this.hexToRgbAGenerate.bind(this)
        //  this.uiEov = this.uiEov.bind(this)
        this.notifyValueEovAllSVSvclog_Local = this.notifyValueEovAllSVSvclog_Local.bind(this)
        this.notifyValueEovAllSVSvclog = this.notifyValueEovAllSVSvclog.bind(this)
        this.factMax = this.factMax.bind(this)
        this.factMin = this.factMin.bind(this)
        this.allMax = this.allMax.bind(this)
        this.allMin = this.allMin.bind(this)
        this.factInfo = {
            unit: 'Total Errors'

        };

        this.xAxis = {
            unit: 'Event Monitor Time'

        };

        this.svTimePositions = this.IGViewDraw.gcTimePositions();
        this.svLast = this.svTimePositions[this.svTimePositions.length - 1];
        this.plotMoneyValue = this.IGViewDraw.gcPlotMoneyValue();
        this.plotMoneyRange = this.IGViewDraw.gcPlotMoneyRange();
        this.svMin = this.svTimePositions[0]

        this.userInboundValues = [{
            name: 'AF',
            y: 56.33
        }, {
            name: 'Media Theater',
            y: 24.03,
            sliced: true,
            selected: true
        }, {
            name: 'Bath',
            y: 10.38
        }, {
            name: 'Pool',
            y: 4.77
        }, {
            name: 'Opera',
            y: 0.91
        }, {
            name: 'Aiport',
            y: 0.2
        }]
        this.userOutboundValues = [40, 60, 80, 100, 120, 140, 160]
        this.userRing = [40, 60, 80, 20, 20, 40, 60]
        this.svmin = 20
        this.svpage = null
        this.graphHrtCat = {
            currentEvent: '10.0.3.1',


            events: [{
                name: 'All Events',
                value: '10.0.3.1'

            }]

        }
    }

    /* sv constructor end.......... */
    componentDidMount() {
        //console.log('sv cdm')
        // this.svNms()

        //console.log(css)
        this.onBiChange()

    }
    // categories = []
    svvis = 'line'

    eovShow = true
    svpage;
    userInboundValues = [
        { name: 'AF', y: 56.33 },
        {
            name: 'Media Theater',
            y: 24.03,
            sliced: true,
            selected: true
        },
        { name: 'Bath', y: 10.38 },
        { name: 'Pool', y: 4.77 }, 
        { name: 'Opera', y: 0.91 },
        { name: 'Aiport', y: 0.2 }
    ]
    userOutboundValues = [40, 60, 80, 100, 120, 140, 160]
    userRing = [40, 60, 80, 20, 20, 40, 60]
    svmin = 20
    svpointer
    hrtShow = true
    hrtValue = {
        container: 'guest-identity',
        svHeading: this.props.svchart.svHeading || 'Peer View',
        svDynaSliceName: 'Sea Day',
        hasAccountValueError: false,
        errorMsg: ''

    }
    //svpointer = this.props.svmetadata.svendpoint
    infoGraph
    SV_DEMO_LOCAL_MIX_MOCK_EOV = false
    svpfLoad = true
    NO_FIELD = 'NO_NAME'
    svGraphEvents = []
    svSpikes = []
    svpointer
    svdepth
    svymax = 200;
    svymin = 0
    CLIENT_CACHE = false
    INCOME_TIME_CLIENT = 1
    svcmpId = 'svortime'
    svtheme = {
        // theme:'SNOW_VENUS'
        theme: 'OCEAN_BLUE'
    }
    stopsColorArray = [
        [
            [0, '#67b261'],
            [1, '#4ca2cd']
        ],
        [
            [0, '#ffbb99'],
            [1, '#ff9966']
        ],

        [
            [0, '#ff0000'],
            [1, '#b30000']
        ],
        [
            [0, '#77b2fa'],
            [1, '#5fa2cd']
        ],
        [
            [0, '#97b2fa'],
            [1, '#2fa2cd']
        ],
        [
            [0, '#23b2fa'],
            [1, '#99a2cd']
        ],
        [
            [0, '#99e600'],
            [1, '#669900']
        ],
        /*sv new */
        [
            [0, '#e64d00'],
            [1, '#cc4400']
        ],
        [
            [0, '#cc99ff'],
            [1, '#b366ff']
        ],
        [
            [0, '#ff704d'],
            [1, '#ff471a']
        ],
        [
            [0, '#e62e00'],
            [1, '#cc2900']
        ],
        [
            [0, '#ffcc00'],
            [1, '#ffd11a']
        ],
        [
            [0, '#b30000'],
            [1, '#990000']
        ],
        [
            [0, '#ffbb99'],
            [1, '#ffaa80']
        ],
        [
            [0, '#b30086'],
            [1, '#990073']
        ],
        [
            [0, '#004080'],
            [1, '#003366']
        ],
        [
            [0, '#00b386'],
            [1, '#009973']
        ],
        [
            [0, '#ff3333'],
            [1, '#ff0000']
        ],
        [
            [0, '#990000'],
            [1, '#800000']
        ],
        [
            [0, '#991f00'],
            [1, '#801a00']
        ],
        [
            [0, '#ac7339'],
            [1, '#996633']
        ],
        [
            [0, '#4d0000'],
            [1, '#330000']

        ],
        [
            [0, '#cc0052'],
            [1, '#b30047']

        ],

        /*sv new.. */
        [
            [0, '#6732fa'],
            [1, '#4f12cd']
        ]




    ]


    hexToRgbA(hex) {
        var c;
        if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
            c = hex.substring(1).split('');
            if (c.length == 3) {
                c = [c[0], c[0], c[1], c[1], c[2], c[2]];
            }
            c = '0x' + c.join('');
            return 'rgba(' + [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(',') + ',1)';
        }
        throw new Error('Bad Hex');
    }

    hexToRgbAGenerate(hex, idx) {
        var c;
        if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
            c = hex.substring(1).split('');
            if (c.length == 3) {
                c = [c[0], c[0], c[1], c[1], c[2], c[2]];
            }
            c = '0x' + c.join('');
            var last = c & 255;
            last = last + idx;
            return 'rgba(' + [(c >> 16) & 255, (c >> 8) & 255, last].join(',') + ',1)';
        }
        throw new Error('Bad Hex');
    }

    /*


 $scope.eovShow = true;
                var SV_DEMO_LOCAL_MIX_MOCK_EOV = false;
                $scope.svpfLoad = true;
                var svpage;
                var NO_FIELD = 'NO_NAME';
                var userInboundValues = [];
                var userOutboundValues = [];
                var userOutboundValues3 = [];
                var userOutboundValues4 = [];
                $scope.svGraphEvents = [];
                var svSpikes = [];

                //var svvis = 'line';
                var svvis = $scope.svchart.svvis;
                
                var svpointer = $scope.svmetadata.svendpoint;
                

                $scope.svdepth = $scope.svmetadata.svdepth;

                
                var svymax = 200;
                var svymin = 0;
                var CLIENT_CACHE = false;
                var INCOME_TIME_CLIENT = 1;
                var svcmpId = 'svortime';
                var svtheme = {
                    // theme:'SNOW_VENUS'
                    theme: 'OCEAN_BLUE'
                };


                 $scope.eovShow = true;
                var SV_DEMO_LOCAL_MIX_MOCK_EOV = false;
                $scope.svpfLoad = true;
                var svpage;
                var NO_FIELD = 'NO_NAME';
                var userInboundValues = [];
                var userOutboundValues = [];
                var userOutboundValues3 = [];
                var userOutboundValues4 = [];
                $scope.svGraphEvents = [];
                var svSpikes = [];

                //var svvis = 'line';
                var svvis = $scope.svchart.svvis;
                
                var svpointer = $scope.svmetadata.svendpoint;
                

                $scope.svdepth = $scope.svmetadata.svdepth;

                
                var svymax = 200;
                var svymin = 0;
                var CLIENT_CACHE = false;
                var INCOME_TIME_CLIENT = 1;
                var svcmpId = 'svortime';
                var svtheme = {
                    // theme:'SNOW_VENUS'
                    theme: 'OCEAN_BLUE'
                };

    */


    /*
    spEovRenderService (json, size, startDate, infoGraph) {

        let me = this

        if (me.eovShow) {



            if (json) {

                if (json.nmi && (json.nmi != null)) {

                    if ((json.nmi)) {



                        me.processPages(json, infoGraph);
                        me.processEvents(json);

                        me.svgrantsGraphPages('page2', size);
                       // me.svAnnotateEvents()
                       me.uiEov()
                       me.redrawOsrBarsInit()


                        me.svGraphicsNetwork()


                    } else {

                        me.spError()


                    }


                } else {
                    me.spError()
                }


            } else {

                me.spError()


            }

        }

    }*/
    svgrantsGraphPages() {



    }

    svPipePointsHeaderNoFilterSvclogAll(dataRawList) {
        var me = this
        var rawCon, catName, raw, points, info, catNamesAll = [];
        points = {
            "smUser": "XXXX",
            "sysdate": 1453323731620,
            "data": {
                "value": {
                    "startDate": "04/27/2017",
                    "endDate": "05/12/2017"
                }
            }
        };
        info = points.data.value;
        if(_.isArray(dataRawList)){
            catName = 'testBrowser'
            catNamesAll.push(catName);
            raw = dataRawList
            this.svPipePointsHeaderNoFilterSvclog_1CatPie(raw, catName, info);
            me.addStopColor(catNamesAll);
            return points;
        }
       

        for (var i = 0; i < dataRawList.length; i++) {
            rawCon = dataRawList[i];
            catName = rawCon.name;
            catNamesAll.push(catName);

            //downstreamValues.aggregations[2].buckets


            // raw = rawCon.data.aggregations[2].buckets;
            if (me.svdepth && _.isNumber(me.svdepth) && (me.svdepth === 3)) {

                var conRaw = rawCon.data.aggregations[2].buckets;
                if (conRaw && conRaw.length < 1) {
                    raw = [];

                } else {
                    raw = conRaw[0][3].buckets;
                }

            
            } else {
                if (rawCon.data.aggregations[2]) {

                    raw = rawCon.data.aggregations[2].buckets;
                } else if (rawCon.data.aggregations[3]) {
                    raw = rawCon.data.aggregations[3].buckets;

                } else {
                    raw = [];
                }

            }
            //console.log('sv--1. raw----------------------')
            //console.log(raw)

            this.svPipePointsHeaderNoFilterSvclog(raw, catName, info);



        }

        me.addStopColor(catNamesAll);
        return points;
    };

    addStopColor(views) {
        var n = views.length;
        var seq = 0;

        for (var i = this.stopsColorArray.length; i < n; i++) {
            var view = [
                [0, '#6732fa'],
                [1, '#4f12cd']
            ];
            view[0][1] = this.hexToRgbAGenerate('#673200', seq);
            view[0][2] = this.hexToRgbAGenerate('#673200', seq + 3);

            this.stopsColorArray.push(view);
            seq++;
        }

    }

    svPipePointsHeaderNoFilterSvclog_1CatPie(dataRaw, catName, info) {
        var me = this
        var points, gob, catNames, reduceCatNames, catNamesAll, info, catName, deck1ValuesAr,

            log, view, parentView,


            deck1ValuesAr = dataRaw;

        /*
        points = {
            "smUser": "XXXX",
            "sysdate": 1453323731620,
            "data": {
                "value": {
                    "startDate": "04/27/2017",
                    "endDate": "05/12/2017"
                }
            }
        };
        info = points.data.value;


        catNames = [$scope.svGraphEdge.currentMetricType.name];
        */

        /*
        catNamesAll = _.allKeys(gob); */

        catNames = [catName];




        //Step 1 always build

        //Step 1 gather categories
        for (var i = 0; i < catNames.length; i++) {
            catName = catNames[i];


            var svcatname = catName;
            info[svcatname] = [];

            for (var k = 0; k < deck1ValuesAr.length; k++) {
                log = deck1ValuesAr[k];
                /*
                if (!(log && (log.y < 1))) {
                    continue;
                }
                */
                view = log;



               // view.y = view.doc_count;

               // view.x = view.key;
               //we are pie so no x values 
                var ob = {
                    "x": view.name,
                    "y": view.y,
                    "name":  view.name,
                    "doc_count": view.doc_count,
                    svMeasure: 'doc_count',
                    COMPUTE_DATE: "6635",




                    biField: 'aggregations',


                    svField: 'svaggregations'

                };
                //we ar pied
                /*
                    {
            "color": "rgba(201, 255, 255,1)",
            "name": "Delta",
            "y": 17.9
        },


                */

                view.x = ob.x;
                view.y = ob.y;
                view.name =  ob.name
                view.doc_count = 10;
                view.svMeasure = 'doc_count'
                    view.COMPUTE_DATE = ob.COMPUTE_DATE;



                info[svcatname].push(view);


            }

            //svorder by x if itis time
            var items = _.clone(info[svcatname]);
            items = me.stackCategoryOrder({
                items: items,
                field: 'x'
            });


            //sunup duplica

            info[svcatname] = items;

            //console.log('----info [' + svcatname + ']-----------------------')
            //console.log(info)
            //filter ar for this catName




        }

        /* 
         
         return points;  */

        //Step 2  use cateforeis and loop

    };
    svPipePointsHeaderNoFilterSvclog(dataRaw, catName, info) {
        var me = this
        var points, gob, catNames, reduceCatNames, catNamesAll, info, catName, deck1ValuesAr,

            log, view, parentView,


            deck1ValuesAr = dataRaw;

        /*
        points = {
            "smUser": "XXXX",
            "sysdate": 1453323731620,
            "data": {
                "value": {
                    "startDate": "04/27/2017",
                    "endDate": "05/12/2017"
                }
            }
        };
        info = points.data.value;


        catNames = [$scope.svGraphEdge.currentMetricType.name];
        */

        /*
        catNamesAll = _.allKeys(gob); */

        catNames = [catName];




        //Step 1 always build

        //Step 1 gather categories
        for (var i = 0; i < catNames.length; i++) {
            catName = catNames[i];


            var svcatname = catName;
            info[svcatname] = [];

            for (var k = 0; k < deck1ValuesAr.length; k++) {
                log = deck1ValuesAr[k];
                if (!(log && (log.key > 1))) {
                    continue;
                }
                view = log;



                view.y = view.doc_count;

                view.x = view.key;
                var ob = {
                    "x": view.x,
                    "y": view.y,
                    "doc_count": view.doc_count,
                    svMeasure: 'doc_count',
                    COMPUTE_DATE: view.key_as_string,




                    biField: 'aggregations',


                    svField: 'svaggregations'

                };

                view.x = ob.x;
                view.y = ob.y;
                view.doc_count = ob.doc_count;
                view.svMeasure = 'doc_count'
                view.COMPUTE_DATE = ob.COMPUTE_DATE;



                info[svcatname].push(view);


            }

            //svorder by x if itis time
            var items = _.clone(info[svcatname]);
            items = me.stackCategoryOrder({
                items: items,
                field: 'x'
            });


            //sunup duplica

            info[svcatname] = items;

            //console.log('----info [' + svcatname + ']-----------------------')
            //console.log(info)
            //filter ar for this catName




        }

        /* 
         
         return points;  */

        //Step 2  use cateforeis and loop

    };

    getSVLeadSeries(ob) {
        let me = this
        this.categories = {};
        me.graphTimeExcel.aggFieldName = 'svoccupancy';
        me.graphTimeExcel.aggTypeName = '';

        _.each(ob, function (v, k) {

            if (v && _.isArray(v)) {
                var boundOb = {},
                    pmax, pmin;
                boundOb.name = k;
                boundOb.userInboundValues = [];
                boundOb.userOutboundValues = [];
                boundOb.userInboundValues = _.clone(v);
                pmax = me.factMax(v);
                if ((!_.isUndefined(pmax))) {
                    boundOb.max = pmax;
                } else {
                    boundOb.max = 120;
                }

                pmin = me.factMin(v);
                if ((!_.isUndefined(pmin))) {
                    boundOb.min = pmin;
                } else {
                    boundOb.min = 0;
                }


                me.categories[k] = boundOb;
            }


        });


    };


/*
    getSVLeadSeriesOrder(ob) {
        let me = this
        categories = {};
        me.graphTimeExcel.aggFieldName = 'svoccupancy';
        me.graphTimeExcel.aggTypeName = '';

        angular.forEach(ob, function (v, k) {

            if (v && angular.isArray(v)) {
                var boundOb = {},
                    pmax, pmin;
                boundOb.name = k;
                boundOb.userInboundValues = [];
                boundOb.userOutboundValues = [];
                boundOb.userInboundValues =_.clone(v);
                pmax = factMax(v);
                if ((angular.isDefined(pmax))) {
                    boundOb.max = pmax;
                } else {
                    boundOb.max = 120;
                }

                pmin = factMin(v);
                if ((angular.isDefined(pmin))) {
                    boundOb.min = pmin;
                } else {
                    boundOb.min = 0;
                }


                categories[k] = boundOb;
            }


        });


    };
*/

    resetDynaOsrEvents() {

        var me = this

        me.graphCat.events = [{


            name: 'All Events',
            value: '10.0.3.1'


        }];

    };

    dynaOsrEvents() {
        var evt, all;
        var me = this

        all = Object.keys(me.categories);
        me.resetDynaOsrEvents();

        for (var i = 0; i < all.length; i++) {
            evt = new Object();
            evt.name = all[i];
            evt.value = all[i];
            me.graphCat.events.push(evt);
        }


    };

    factMax(views) {
        var fact, view;
        view = _.max(views, function (item) {
            return item.y;
        });
        if (view && (view.y)) {
            fact = view.y;

        } else {
            fact = 100;
        }
        return fact;

    };

    factMin(views) {
        var fact, view;
        view = _.min(views, function (item) {
            return item.y;
        });
        if (view && (view.y)) {
            fact = view.y;

        } else {
            fact = 0;
        }
        return fact;

    };

    allMax(categories) {
        var tmax = 0;
        

        _.each(categories, function (v, k) {

            if (_.isDefined(v.max) && (_.isNumber(v.max))) {
                if (v.max > tmax) {
                    tmax = v.max;
                }
            }

        });


    };

    allMin(categories) {
        var tmin = 0;
        let tmax = 0;

        _.forEach(categories, function (v, k) {

            if (_.isDefined(v.min) && (_.isNumber(v.min))) {
                if (v.min > tmin) {
                    tmax = v.max;
                }
            }

        });


    };
    
    stackCategoryOrder(options) {
        var viewItems = options.items;
        var field = options.field;
        var catItems = _.sortBy(viewItems, field);
        return catItems;

    }

    onBiChange() {
        //obTop
        let me = this
        let obTop = {
            value: 'SVBITYPE_SVCLOG'
        }
       let  biProduct = 'SVBITYPE_SVCLOG'
        let obAccount
        this.CLIENT_CACHE = false;

        if (obTop.value === 'svssnmp') {
            //sv handled by different comp

            return;
        }
        if (obTop.value === 'svorder') {
            /*
                        biProduct = 'SVBITYPE_PRODUCT';
                        $scope.svGraphEdge =_.clone(graphEdgeOrder);
                        $scope.svGraphEdge.filterState.quantity = 0;
                        $scope.svGraphEdge.filterState.list_unit_price = 0;
                        $scope.svGraphEdge.filterState.product_type = '';
                        $scope.svGraphEdge.filterState.shipment_type = '';
                        $scope.svGraphEdge.filterState.timestamp = '';
                        $scope.svGraphEdge.filterState.svreportType = biProduct;
                        factInfo.unit = 'Amount($)';
            
                        $scope.svGraphEdge.filterState.isfilterApplied = false;
                        reportMetaData =_.clone(biMetaDataOrder); */
        } else if (obTop.value === 'SVBITYPE_SVCLOG') {
            /*  this.biProduct = 'SVBITYPE_SVCLOG';
              this.svGraphEdge = _.clone(graphEdgeSvclog);
              this.svGraphEdge.filterState.doc_count = 0;
  
  
              this.svGraphEdge.filterState.isfilterApplied = false;
              this.svGraphEdge.filterState.svreportType = biProduct;
              factInfo.unit = 'doc_count';
  
  
             this.svGraphEdge.currentVessel.topName = obTop.name || 'All';
              this.svGraphEdge.currentVessel.topValue = obTop.value || 'svall';
              this.reportMetaData = _.clone(biMetaDataSVSvclog);*/
            //svwed
            this.biProduct = 'SVBITYPE_SVCLOG';

            this.svGraphEdge.startLong = this.props.svitin.startLong
            this.svGraphEdge.endLong = this.props.svitin.endLong
         
            this.svHrtGraphEdge = _.clone(me.graphEdgeSvclog);
            this.svHrtGraphEdge.filterState.doc_count = 0;
            /*
            this.svHrtGraphEdge.filterState.isfilterApplied = false;
            this.svHrtGraphEdge.filterState.svreportType = biProduct;
            */
            this.svGraphEdge.filterState.isfilterApplied = false;
            this.svGraphEdge.filterState.svreportType = biProduct;
            this.factInfo.unit = 'doc_count';


            this.svHrtGraphEdge.currentVessel.topName = obTop.name || 'All';
            this.svHrtGraphEdge.currentVessel.topValue = obTop.value || 'svall';
            this.reportMetaData = _.clone(this.biMetaDataSVSvclog);

        } else if (obTop.value === 'SVBITYPE_OCCUPANCY') {
            /*  biProduct = 'SVBITYPE_OCCUPANCY';
                         // $scope.hrtValue.svHeading = 'Peer View';
                           $scope.hrtValue.svDynaSliceName= 'Sea Day';
                          $scope.svHrtGraphEdge =_.clone(graphEdgeOccupancy);
                          $scope.svHrtGraphEdge.filterState.lln = '';
                          $scope.svHrtGraphEdge.filterState.day = '';
                          $scope.svHrtGraphEdge.filterState.isfilterApplied = false;
                           $scope.svHrtGraphEdge.filterState.svreportType = biProduct;
                           factInfo.unit = 'Occupancy';
  
  
                          $scope.svHrtGraphEdge.currentVessel.topName = obTop.name || 'All';
                          $scope.svHrtGraphEdge.currentVessel.topValue = obTop.value || 'svall';
                          reportMetaData =_.clone(biMetaDataOccupancy);*/

        } else {
            /*  biProduct = 'SVBITYPE_OCCUPANCY';
              $scope.svGraphEdge =_.clone(graphEdgeOccupancy);
              $scope.svGraphEdge.filterState.lln = '';
              $scope.svGraphEdge.filterState.day = '';
              $scope.svGraphEdge.filterState.isfilterApplied = false;
              $scope.svGraphEdge.filterState.svreportType = biProduct;
              factInfo.unit = 'Occupancy';
  
  
              $scope.svGraphEdge.currentVessel.topName = obTop.name || 'All';
              $scope.svGraphEdge.currentVessel.topValue = obTop.value || 'svall';
              reportMetaData =_.clone(biMetaDataOccupancy);
  */
        }




        me.svGraphEdge.currentVessel.topName = obTop.name || 'All';
        me.svGraphEdge.currentVessel.topValue = obTop.value || 'svall';



        var rq = {
            accountId: 21
        };
        obAccount = {};
        me.exrerciseLoadService(rq, obAccount);
    }

    extractOrder(topOrLastN) {
        var n = 1,
            pos = 0,
            ob = {
                order: 'last',
                n: 5

            };
        if (topOrLastN.indexOf('top') > -1) {
            pos = topOrLastN.indexOf('top') + 3;
            n = topOrLastN.substr(pos, topOrLastN.length);
            ob.n = parseInt(n);
            ob.order = 'top';

        } else if (topOrLastN.indexOf('last') > -1) {

            pos = topOrLastN.indexOf('last') + 4;
            n = topOrLastN.substr(pos, topOrLastN.length);
            ob.n = parseInt(n);
            ob.order = 'last';

        }
        return ob;

    }
    exrerciseLoadService(rq, obAccount) {

        this.globalAllocationHrtSV(obAccount)
        // this.globalAllocationValueEovSV_ConstructSeries(obAccount);
    }
    /*
     globalAllocationValueEovSV_ConstructSeries(obAccount) {
         let me = this
         let biProduct = 'SVBITYPE_SVCLOG'
       


        var calls;

        if (biProduct == 'SVBITYPE_PRODUCT') {

            if (obAccount && obAccount.query) {



                calls = [me.notifyValueEovAllSVProduct(obAccount.query)];
            } else {

                calls = [me.notifyValueEovAllSVProduct()];
            }
        } else if (biProduct == 'SVBITYPE_SLOG') {

            if (obAccount && obAccount.query) {



                calls = [me.notifyValueEovAllSVSlog_Local(obAccount.query)];
            } else {

                calls = [me.notifyValueEovAllSVSlog_Local()];
            }

        } else if (biProduct == 'SVBITYPE_SVCLOG') {

            if (obAccount && obAccount.query) {



                calls = [me.notifyValueEovAllSVSvclog(obAccount.query), me.notifyValueEovAllSVAnnotateEvent_Local(obAccount.query)];
            } else {

                calls = [me.notifyValueEovAllSVSvclog(),me.notifyValueEovAllSVAnnotateEvent_Local()];
            }


        } else {

            //sv

            if (obAccount && obAccount.accountId) {

                if (obAccount.encAccountId) {

                } else {
                    obAccount.encAccountId = obAccount.accountNumber;
                }

                calls = [me.notifyValueEovAllSV(obAccount.encAccountId)];
            } else {

                calls = [me.notifyValueEovAllSV(obAccount.encAccountId)];
            }

            //sv.. 


        }
       
        Promise.all(calls)
            .then(function(alloc) {
                var downstreamValues = alloc[0],
                    allValues, raw,
                    pastValues,
                    outbound,


                    error = false,
                    annualValues,
                    statusCode,
                    svFunded = true,
                    infoGraph, modellerRs = {
                        data: {
                            value: {}
                        }
                    };

                  //  downstreamValues = alloc[0].data.value.payload
                var statusInfo = null,
                    flatAr;

                //Step 0 transform to 
                //sva30
                if (biProduct == 'SVBITYPE_PRODUCT') {
                    allValues = me.svPipePointsSlr(downstreamValues);
                    // allValues = svPipePoints(downstreamValues);
                } else if (biProduct == 'SVBITYPE_SLOG') {
                    flatAr = downstreamValues.data.list.events;
                    downstreamValues = flatAr;

                    allValues = me.svPipePointsHeaderNoFilterSlog(downstreamValues);



                } else if (biProduct == 'SVBITYPE_SVCLOG') {
                  // flatAr = alloc[0].data.value.payload.aggregations[2].buckets;
                    flatAr = downstreamValues.data.list;
                   // flatAr =  downstreamValues.aggregations[2].buckets;
                    downstreamValues = flatAr;

                    allValues = me.svPipePointsHeaderNoFilterSvclogAll(downstreamValues);

                  //  var clips = alloc[1] || [];
                  var clips = []
                    me.svPipeEvents(clips);
                    

                } else {
                    // allValues = svPipePointsSlr(downstreamValues);
                    allValues = me.svPipePoints(downstreamValues);
                }

                //sva30..
               
                //Step 1 get all series
                if (allValues && allValues.data.value) {
                    raw = allValues.data.value;
                    //Step get series


                    //Step 2 get max for y
                    //Step 3 get min for y
                    //Step 4 get data 

                    modellerRs.startDate = raw.startDate;
                    modellerRs.endDate = raw.endDate;

                    me.getSVLeadSeries(raw);
                    me.dynaOsrEvents();
                    if (me.CLIENT_CACHE === true) {
                        svcache = _.clone(categories);
                    }




                    var firstSeriesName = _.keys(me.categories)[0];
                    var firstSeries = me.categories[firstSeriesName];
                    if (firstSeries && firstSeries.userInboundValues) {

                        me.userInboundValues = _.clone(me.categories[firstSeriesName].userInboundValues);

                        modellerRs.nmi = _.clone(me.categories[firstSeriesName].userInboundValues);
                        modellerRs.nmo = _.clone(me.categories[firstSeriesName].userInboundValues);
                        modellerRs.page = me.categories;

                    }





                } else {

                    
                    
                    return;
                }


               me.networkValue.hasAccountValueError = false;
                //SV TOdDO put infograpg hardcoded for 1 year

                infoGraph = {
                    ai: {
                        svac_range: ["May 1, 2017 - May 31, 2017", "Jun 1, 2017 - Jun 30, 2017", "Jul 1, 2017 - Jul 31, 2017", "Aug 1, 2017 - Aug 31, 2017", "Sep 1, 2017 - Sep 30, 2017", "Oct 1, 2017 - Oct 31, 2017", "Nov 1, 2017 - Nov 30, 2017", "Dec 1, 2017 - Dec 31, 2017", "Jan 1, 2018 - Jan 31, 2018", "Feb 1, 2018 - Feb 28, 2018", "Mar 1, 2018 - Mar 31, 2018", "Apr 1, 2018 - Apr 30, 2018", "May 1, 2018 - May 1, 2018"],
                        svac_totalinm_m: [100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112],
                        svac_totalonm_m: [200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212],
                        svall: 3000
                    }
                };



             

                if (error === true) {
                    return me.spError();
                }
                me.spEovRenderService(modellerRs, null, null, infoGraph);
                //svmessageToAF();


                //sv..
            });

    }; */
    svPipeEvents(dataAn) {
        var me = this
        /*case no annotateevents return */
        if (dataAn.data) {

        } else {
            me.svGraphEvents = []
            return
        }
        /*case no annotateevents return.. */
        var dataRaw = dataAn.data.list[0].data;

        var events = [],
            event, view, containerName, items;
        me.svGraphEvents = [];



        if ((dataRaw && dataRaw.hits && dataRaw.hits.hits)) {

            events = dataRaw.hits.hits;
        } else {



        }
        //make all this dynamic based onnthe fields configured
        for (var i = 0; i < events.length; i++) {

            event = events[i];
            view = _.clone(event['_source']);

            view = view || {};
            view.x = event['fields']['@timestamp'][0];
            containerName = event["_source"]["containerName"];
            items = containerName.split('.');
            view.eventType = 'container_restart';
            view.containerId = items[2] || NO_FIELD;
            view.replicaId = items[1] || NO_FIELD;
            view.service = items[0] || NO_FIELD;
            view.elkType = event['_type'];
            view.elkId = event['_id'];
            view.elkIndex = event['_index'];
            view['startupTime'] = '22.969';
            me.svGraphEvents.push(view);

        }



    }
    processPagesPeer(value, infoGraph) {
        let me = this
        var error = false,
            items,
            startDate = value.startDate,
            endDate = value.endDate,
            startLong, endLong;
        if (value && (value != null)) {

        } else {
            error = true;
        }
        if (error) {
            return;
        }
        //userOutboundValues =_.clone(value.nmo);
        //  userInboundValues =_.clone(value.nmi);

        //
        me.userInboundValues = [...value.nmi]
        me.svpage = value.page;
        infoGraph = value.nmi;

    };
    processPagesPeer_org_nov25(value, infoGraph) {
        let me = this
        var error = false,
            items,
            startDate = value.startDate,
            endDate = value.endDate,
            startLong, endLong;
        if (value && (value != null)) {

        } else {
            error = true;
        }
        if (error) {
            return;
        }
        //userOutboundValues =_.clone(value.nmo);
        //  userInboundValues =_.clone(value.nmi);

        //
       
        me.svpage = value.page;
        infoGraph = value.nmi;

    };
    /*
    processPages(value, infoGraph){
        let me = this
        var error = false,
        items,
        startDate = value.startDate,
        endDate = value.endDate,
        startLong, endLong;

        

    //startDate = value.startDate;

                if (value && (value != null)) {

                } else {
                    error = true;
                }
                if (error) {
                    return;
                }


    
            
            this.svpage = value.page;
            this.userOutboundValues =[...value.nmo]
            this.userInboundValues = [...value.nmi]
    // userOutboundValues3 = _.clone(value.nmo3);
    //   userOutboundValues4 = _.clone(value.nmo4);



    //svstep find the last
        var posStart, posEnd, NUM_TICKS = 10, step,cur

        if(me.userInboundValues[0]){
            posStart = me.userInboundValues[0].x
                posEnd = me.userInboundValues[me.userInboundValues.length - 1].x;
                NUM_TICKS = 10;

                    step = Math.floor((posEnd - posStart) / NUM_TICKS);
                    
                    me.svTimePositions = []
                    me.svTimePositions[0] = posStart;

                    me.svMin = me.svTimePositions[0]

                    cur = me.svMin;
                    for (var i = 0; i < NUM_TICKS; i++) {

                        cur += step;
                        me.svTimePositions.push(cur);
                    }

                    
                    me.svLast = me.svTimePositions[me.svTimePositions.length - 1];
        //find last 

        }else{

        }

    
        
        //find step

        me.infoGraph = value.nmi;
        me.persistAccountData()
        me.updateDataPageLoad(infoGraph)
    
    }
*/


    //userAccountValues = infoGraph;
    persistAccountData() {

    }
    updateDataPageLoad(infoGraph) {

    }
    processEvents() {

    }

    svAnnotateEvents() {
        console.log('sv--TODOD svAnnotateEvents---')
    }

    redrawOsrBarsInit() {
        //console.log('sv--TODOD redrawOsrBarsInit---')

        var svdyna, names;
        //lets show 2 and empty all
        names = Object.keys(this.categories);
        var ob

        for (var i = 0; i < names.length; i++) {

            /*if(i==2){
                continue;
            }*/
            ob = this.categories['' + names[i]];
            this.eovSpread.addSeries({

                name: ob.name,
                /* color: 'rgba(223, 83, 83, .5)', */
                color: {
                    linearGradient: {
                        x1: 0,
                        y1: 0,
                        x2: 0,
                        y2: 1
                    },
                    stops: this.stopsColorArray[i]
                },
                data: _.clone(ob.userInboundValues)

            }, false);




        }

        // this.eovSpread.redraw();

    }
    svAnEvent() {
        console.log('--- todod svAnEvent')
    }
    svGraphicsNetwork() {
        console.log('--- svGraphicsNetwork')
    }
    spError() {
        console.log('--- spError')

    }
    notifynotifyValueEovAllSVAnnotateEvent_Local(encryptedIndividualAccount) {
        // let me = this, url = 'http://localhost:3004/svelkParallelSearch'

        let me = this, url = 'http://localhost:3004/elkOsrChart'
        var deferred,
            quote;

        if (me.svcall && me.svserver) {
            url = me.svserver + '/' + me.svcall
            //console.log('sv endpoint -------------' + url)
        }

        if (this.svCallType != 'POST') {
            if (this.props.svmetadata.svQueryGet && (this.props.svmetadata.svQueryGet.length > 0)) {
                url = me.svserver + '/' + me.svcall + '/' + this.props.svmetadata.svQueryGet
            }
            //console.log('sv endpoint GET-------------' + url)
            return fetch(url)
                .then((rs) => {
                    return rs.json()

                })
                .catch((e) => {
                    console.log('service error')
                    Promise.resolve(e)

                })
        }
        //console.log('sv endpoint POST-------------' + url)
        var svrq = {};
        if (encryptedIndividualAccount && (encryptedIndividualAccount != null)) {

            svrq = {
                "value": {
                    "vessel": me.svGraphEdge.currentVessel.value,
                    "query": encryptedIndividualAccount,
                    "startRecord": ""
                }
            };

        } else {

            svrq = {
                "value": {
                    "query": "",
                    "startRecord": ""
                }
            };

        }
        svrq.value.startLong = me.svGraphEdge.svtimeRange.startLong;
        svrq.value.endLong = me.svGraphEdge.svtimeRange.endLong;


        //svelkParallelSearch


        // SVStrategyServices.svSvclogIntelligenceAELocal_couch(svrq)

        let postRq = {
            method: 'POST',
            body: JSON.stringify(svrq),
            headers: {
                'Accept-Type': 'application/json',
                'Content-Type': 'application/json'
            }
        }


        return fetch(url, postRq)
            .then((rs) => {
                return rs.json()

            })
            .catch((e) => {
                console.log('service error')
                Promise.resolve(e)

            })

    }
    notifyValueEovAllSVSvclog_Local(encryptedIndividualAccount) {
        //svcarn_httperror_30m_all.json
        let me = this, url = 'http://localhost:3004/elkOsrChart'
        var deferred,
            quote;


        var svrq = {};
        if (encryptedIndividualAccount && (encryptedIndividualAccount != null)) {

            svrq = {
                "value": {
                    "vessel": me.svGraphEdge.currentVessel.value,
                    "query": encryptedIndividualAccount,
                    "startRecord": ""
                }
            };

        } else {

            svrq = {
                "value": {
                    "query": "",
                    "startRecord": ""
                }
            };

        }
        // SVStrategyServices.svSvclogIntelligence(svrq)
        // data.accomodation


        let postRq = {
            method: 'POST',
            body: JSON.stringify(svrq),
            headers: {
                'Accept-Type': 'application/json',
                'Content-Type': 'application/json'
            }
        }
        return fetch(url, postRq)
            .then((rs) => {
                return rs.json()

            })
            .catch((e) => {
                console.log('service error')
                Promise.resolve(e)

            })


    };
    notifyValueEovAllSVSvclog(encryptedIndividualAccount) {
        let me = this, url = 'http://localhost:3004/elkOsrChart'
        //svcarn_httperror_30m_all.json
        var deferred,
            quote;


        var svrq = {};
        if (encryptedIndividualAccount && (encryptedIndividualAccount != null)) {

            svrq = {
                "value": {
                    "vessel": "v1",
                    "query": encryptedIndividualAccount,
                    "startRecord": ""
                }
            };

        } else {

            svrq = {
                "value": {
                    "query": "",
                    "startRecord": ""
                }
            };

        }

        svrq.value.startLong = me.svGraphEdge.svtimeRange.startLong;
        svrq.value.endLong = me.svGraphEdge.svtimeRange.endLong;
        svrq.value.svEnv = me.svGraphEdge.svtimeRange.svEnv;





        // SVStrategyServices.svSvclogIntelligence(svrq)
        // data.accomodation svSvclogIntelligenceAllTrident
        //SVStrategyServices.svSvclogIntelligenceAllTrident(svrq)
        let postRq = {
            method: 'POST',
            body: JSON.stringify(svrq),
            headers: {
                'Accept-Type': 'application/json',
                'Content-Type': 'application/json'
            }
        }
        return fetch(url, postRq)
            .then((rs) => {
                return rs.json()

            })
            .catch((e) => {
                console.log('service error')
                Promise.resolve(e)

            })


        /*  SVStrategyServices['' + svpointer](svrq)
              .error(function(e) {
                  deferred.reject(e);
                  spError();
  
              })
              .success(
                  function(rs) {
                      deferred.resolve(rs);
  
  
  
                  });
  
  
          return deferred.promise; */

    };
    /*
    uiEov(json) {

                    
        var baseFormat = this.IGViewDraw.gcDomainGuide();
        var layerTheme = this.IGViewDraw.svOceanLayer(this.svtheme);
        var id = ('#' + this.props.svchart.svid)
        let me = this
        console.log('sv chart id:'+this.props.svchart.svid)
        var el =Highcharts.chart( this.props.svchart.svid,{

            // var el = $('#svieov').highcharts({


            title: {
                text: ''
            },
            chart: {
                //  type: 'scatter',
                type: me.svvis,
              
                zoomType: 'xy'
            },
          
            subtitle: {
                // text: 'DNS Probe: 2017'
                text: ''
            },
            xAxis: {
                title: {
                    enabled: true,
                    text:'HCTime'
                  //  text: xAxis.unit
                },
               
                 plotLines :me.svSpikes,



                labels: {
                    useHTML: me.IGViewDraw.gcDomainMode(false),
                  
                    gridLineColor:'#0066cc',
                    lineColor:'red',

                    style: { "color": "#99ccff", "opacity":0.8, "cursor": "default", "fontSize": "10px" },
                  

                },
                gridLineColor: '#00111a',
                startOnTick: true,
                endOnTick: true,
                ordinal: false,
                minorTickColor: '#ffffff',
                minorTickLength: 10,

                // min: svMin,

                //max: svLast,



                zIndex: 1,

                maxPadding: 0,
                minPadding: 0,



                type: 'datetime',

                dateTimeLabelFormats: { // don't display the dummy year
                    month: '%e. %b',
                    year: '%b'
                },
                showLastLabel: true
            },
           
            yAxis: {
                gridLineColor: layerTheme.layer,
                lineColor: layerTheme.plate,

               


                // gridLineColor:'#fff',
                labels: {
                    useHTML: true,
                   
                      style: { "color": "#99ccff", "opacity":0.8, "cursor": "default", "fontSize": "10px" },
                 
                },
                title: {
                    text: me.factInfo.unit || 'unit'
                }
            },

            exporting: {
                buttons: {
                    contextButton: {
                        menuItems: [{
                            text: 'Export to PNG (small)',
                            onclick: function() {
                                this.exportChart({
                                    width: 250
                                });
                            }

                        }, {
                            text: 'Generate Report',
                            onclick: function() {
                              //  $rootScope.$broadcast('SV_OR_AGG_REPORT', ['gen', svcmpId]);
                            },
                            separator: false

                        }, {
                            text: 'Export to PNG (large)',
                            onclick: function() {
                                me.exportChart();
                            },
                            separator: false
                        }]
                    }
                }
            },
            

            legend: {
               
                useHTML: true,
                itemStyle: {
                    "color": "#666666",
                    "cursor": "pointer",
                    "fontSize": "12px",
                    "fontWeight": "bold",
                    "textOverflow": "ellipsis"
                },
                backgroundColor: me.IGViewDraw.svOceanTheme(me.svtheme).backgroundColor,
                color: '#666666',

               
                enabled: true,
                reversed: true
            },
            plotOptions: {
               
                scatter: {
                    marker: {
                        radius: 8,
                        states: {
                            hover: {
                                enabled: true,
                                lineColor: 'rgb(100,100,100)'
                            }
                        }
                    },
                    states: {
                        hover: {
                            marker: {
                                enabled: false
                            }
                        }
                    },

                   
                }
            },

            //   series: IGViewDraw.gcGraphs(userInboundValues, plotMoneyValue, plotMoneyRange)
            series: [{



                name: 'svpersist',
                visible: false,
                
                color: {
                    linearGradient: {
                        x1: 0,
                        y1: 0,
                        x2: 0,
                        y2: 1
                    },
                    stops: [
                        [0, '#67b261'],
                        // [0,'#3d0099'],
                        [1, '#4ca2cd']
                        //   [1, '#000066']
                    ]
                },
                data: me.userInboundValues



            }]

        });

        //svhc..
        me.eovSpread = el;
        console.log(' me.eovSpread------------------')
        console.log(me.eovSpread)
     //  me.eovSpread = el.highcharts();




    };
*/

    componentWillMount() {
        console.log('svnms m');
        // this.svNms() 

    }



    svRefreshBucket() {
        //console.log('svrefreshbucket')
        this.onBiChange()
        /*
                setTimeout(()=>{
                    console.log('_______________TN1__________________')
        //            this.svNms()
                    this.setState({searchText:'hello'})
        
                   
                  
        
                },70)
               */
        // this.svNms() 

    }



    svNms() {
        //console.log('svnms---')

        // let svres = ReactDOM.findDOMNode(this.refs.svres)
        //  $(svres).empty()

        Highcharts.chart('svciosr', {
            chart: {
                plotBackgroundColor: null,
                plotBorderWidth: null,
                plotShadow: false,
                type: 'pie'
            },
            title: {
                text: 'Browser market shares. January, 2015 to May, 2015'
            },

            plotOptions: {
                pie: {
                    allowPointSelect: true,
                    cursor: 'pointer',
                    /* dataLabels: {
                         enabled: true,
                         format: '<b>{point.name}</b>: {point.percentage:.1f} %',
                         style: {
                             color: (Highcharts.theme && Highcharts.theme.contrastTextColor) || 'black'
                         },
                         connectorColor: 'silver'
                     }*/
                }
            },
            series: [{
                name: 'Brands',
                data: [
                    { name: 'Microsoft Internet Explorer', y: 56.33 },
                    {
                        name: 'Chrome',
                        y: 24.03,
                        sliced: true,
                        selected: true
                    },
                    { name: 'Firefox', y: 10.38 },
                    { name: 'Safari', y: 4.77 }, { name: 'Opera', y: 0.91 },
                    { name: 'Proprietary or Undetectable', y: 0.2 }
                ]
            }]
            // options - see https://api.highcharts.com/highcharts
        });
        //console.log('sv draw done')
        // this.networkSpread= el.highcharts();
        //  this.state({ networkSpread:el.highcharts()}) ;

    }


    render_blue() {
        let me = this
        let hdbFirstView = 'hdb-pad-left-10'
        //console.log('sv nms render')
        //console.log('sv-----------------------------luaout--'+ me.svlayout)
        return (





            <div className={me.svlayout}>


               
                <h4 style={{ "padding-left": "10px;" }} className={hdbFirstView}><a><span className="svhdb-cmp-title">{me.props.svchart.svHeading}</span>
                    <span onClick={me.svRefreshBucket} className="et-icon-refresh lastRefresh" > </span>


                </a></h4>

                <div className="igTimePeriodContainer clearfix"  >

                    <div ref="svresSVChart2" id_THOUSE="svciosr" id={me.props.svchart.svid} className="row-fluid voffset2 svlist-mvevt-row sv-account-chart-container svmodelvalue-box" style={{ 'width': '100%', 'padding-top': '20px', 'margin': 0 }}> </div>

                </div>
              
                <div className="row" style={{ display: 'none' }}>
                    <div className="pull-right">
                        <a className="btn btn-default" onClick={me.svRefreshBucket}>RefreshArea </a>
                    </div>



                </div>






            </div>


        )
    }

    

    render_bad() {
        let me = this
        let hdbFirstView = 'hdb-pad-left-10'
        //console.log('sv nms render')
        //console.log('sv-----------------------------luaout--'+ me.svlayout)
        return (
            <div>
                <div className="row-fluid voffset2 svlist-mvevt-row sv-account-chart-container svmodelvalue-box" style={{ 'width': '100%', 'minwidth': '310px', 'padding-top': '20px', 'margin': 0 }} id="svciosr"></div>
                <span onClick={me.svRefreshBucket} className="glyphicon glyphicon-refresh" > AsmDocUpdate</span>
            </div>
        )
    }

    render() {
        let me = this
        let hdbFirstView = 'hdb-pad-left-10'
        //console.log('sv nms render')
        //console.log('sv-----------------------------luaout--'+ me.svlayout)
        return (





            <div className={me.svlayout}>


               
                <h4 style={{ "padding-left": "10px;" }} className={hdbFirstView}><a><span className="svhdb-cmp-title">{me.props.svchart.svHeading}</span>
                    <span onClick={me.svRefreshBucket} className="et-icon-refresh lastRefresh" > </span>


                </a></h4>

                <div className="igTimePeriodContainer clearfix"  >

                    <div ref="svresSVChart2" id_THOUSE="svciosr" id={me.props.svchart.svid} className="row-fluid voffset2 svlist-mvevt-row sv-account-chart-container svmodelvalue-box" style={{ 'width': '100%', 'padding-top': '20px', 'margin': 0 }}> </div>

                </div>
              
               






            </div>


        )
    }
}